// migrated 1:1 from @nexato/nx-core-module, #712 (was never migrated during the framework merge, #669)
import { Component, forwardRef, Injector, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR, NgControl, Validators } from '@angular/forms';

@Component({
  selector: 'nx-edit-color-input',
  template: `
    <div>
      <label for="text">{{label | translate}}<ng-container *ngIf=isRequired()>*</ng-container></label>
      <div class="flex flex-row items-center gap-2">
        <input
          [type]="'text'"
          [value]="color"
          (input)="onInputChange($event)"
          (blur)="onBlur()"
          [placeholder]="placeholder | translate"
          id="text"
          pInputText
          [disabled]="isDisabled"
          [ngClass]="{'invalid': ngControl?.invalid && ngControl?.touched}"
        />
        <div class="w-10">
          <p-colorPicker [ngModel]="color" appendTo="body" (onChange)="selectColorFromPicker($event)" class="mt-1"></p-colorPicker>
        </div>
      </div>
      <div class="color-presets">
        <div class="color-grid flex flex-wrap ml-2 mt-1" id="colorGrid">
          <div
            *ngFor="let preset of colorPresets"
            class="color-option w-6 h-6 rounded cursor-pointer mr-1 mb-1"
            [style.background-color]="preset"
            [attr.data-color]="preset"
            (click)="selectColor(preset)">
          </div>
        </div>
      </div>
      <small *ngIf="helpText">{{helpText | translate}}</small>
      <small class="error" *ngIf="ngControl?.errors?.invalidHexColor">Ungültige Farbe (Hex-Format erwartet).</small>
    </div>
  `,
  styles: [`
    .color-option { border: 0.063rem solid #e4e4e4; }
    .color-option:hover { border: 0.063rem solid #9ca3af; }
  `],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EditColorInputComponent),
      multi: true
    }
  ]
})
export class EditColorInputComponent implements ControlValueAccessor, OnInit {

  ngControl: NgControl;
  isDisabled: boolean;
  @Input() label: string;
  @Input() placeholder: string = '';
  @Input() helpText: string;
  @Input() colorPresets: string[] = [
    '#e91e63', '#f44336', '#c2185b', '#ff5722', '#ff9800', '#ffeb3b',
    '#4caf50', '#81c784', '#2196f3', '#e1bee7', '#9c27b0', '#673ab7',
    '#607d8b', '#795548'
  ];

  color: string;

  private onChange: (value: string) => void;
  private onTouched: () => void;

  constructor(private _injector: Injector) {}

  ngOnInit() {
    this.ngControl = this._injector.get(NgControl);
    this.ngControl.valueAccessor = this;
  }

  writeValue(color: string): void { this.color = color; }
  registerOnChange(fn: (value: string) => void): void { this.onChange = fn; }
  registerOnTouched(fn: () => void): void { this.onTouched = fn; }
  setDisabledState?(isDisabled: boolean): void { this.isDisabled = isDisabled; }

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.color = input.value;
    if (this.onChange) { this.onChange(this.color); }
  }

  onBlur(): void { if (this.onTouched) { this.onTouched(); } }

  isRequired(): boolean {
    return this.ngControl?.control?.hasValidator(Validators.required);
  }

  selectColor(color: string): void {
    this.color = color;
    if (this.onChange) { this.onChange(this.color); }
  }

  selectColorFromPicker(event: any): void {
    if (event && event.value) {
      this.color = event.value;
      if (this.onChange) { this.onChange(this.color); }
    }
  }
}
